module.exports = __webpack_public_path__ + "static/img/PC-1.0f1f02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcga/PC-1.png
// module id = +fNi
// module chunks = 0